import { ApiBase } from '@orca/api-base';
import { useQuery } from '@tanstack/react-query';

import { QUERIES_KEY } from '~/constants/queries_key';

export const useUserSettings = () => {
  return useQuery(
    [QUERIES_KEY.userSettings],
    () => {
      return ApiBase.users.settings();
    },
    {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 5000,
      refetchOnMount: false,
      refetchOnReconnect: false,
    }
  );
};
